import { Link } from "react-router-dom";

const footerLinks = [
  {
    title: "热门分类",
    links: [
      { name: "网红翻车", href: "/category/influencer-flop" },
      { name: "明星黑料", href: "/category/celebrity-scandal" },
      { name: "社会热点", href: "/category/social-hot" },
      { name: "每日吃瓜", href: "/category/daily-gossip" },
    ],
  },
  {
    title: "关于我们",
    links: [
      { name: "品牌介绍", href: "/about" },
      { name: "联系我们", href: "/about" },
      { name: "投稿爆料", href: "/about" },
      { name: "隐私政策", href: "/about" },
    ],
  },
  {
    title: "联系方式",
    links: [
      { name: "邮箱：tips@911chigua.com", href: "mailto:tips@911chigua.com" },
      { name: "微信：911chigua", href: "#" },
      { name: "微博：@911吃瓜网", href: "#" },
      { name: "Telegram：@chigua911", href: "#" },
    ],
  },
];

const socialIcons = [
  { icon: "ri-weibo-line", label: "微博", href: "#" },
  { icon: "ri-wechat-line", label: "微信", href: "#" },
  { icon: "ri-telegram-line", label: "Telegram", href: "#" },
  { icon: "ri-twitter-x-line", label: "Twitter", href: "#" },
];

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2">
            <Link
              to="/"
              className="inline-block font-heading text-3xl md:text-4xl font-bold tracking-tight mb-6 hover:opacity-80 transition-opacity"
            >
              911<span className="text-primary-400">吃瓜网</span>
            </Link>
            <p className="text-foreground-300 text-sm leading-relaxed max-w-sm mb-6">
              每日更新网红翻车、明星黑料、社会热点爆料，独家吃瓜资源一站获取，随时随地看最新大瓜。
            </p>
            <div className="flex items-center gap-3">
              {socialIcons.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="w-9 h-9 rounded-full border border-foreground-600 flex items-center justify-center text-foreground-400 hover:text-primary-400 hover:border-primary-400 transition-colors"
                  aria-label={social.label}
                >
                  <i className={`${social.icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-xs font-semibold uppercase tracking-wider text-foreground-400 mb-4">
                {group.title}
              </h4>
              <ul className="space-y-3">
                {group.links.map((link) => (
                  <li key={link.name}>
                    {link.href.startsWith("mailto:") ? (
                      <a
                        href={link.href}
                        className="text-sm text-foreground-300 hover:text-primary-400 transition-colors"
                      >
                        {link.name}
                      </a>
                    ) : link.href.startsWith("/") ? (
                      <Link
                        to={link.href}
                        className="text-sm text-foreground-300 hover:text-primary-400 transition-colors"
                      >
                        {link.name}
                      </Link>
                    ) : (
                      <a
                        href={link.href}
                        target="_blank"
                        rel="nofollow noopener noreferrer"
                        className="text-sm text-foreground-300 hover:text-primary-400 transition-colors"
                      >
                        {link.name}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="border-t border-foreground-800">
        <div className="px-4 md:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 911吃瓜网 版权所有
          </p>
          <div className="flex items-center gap-6">
            <Link
              to="/about"
              className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors"
            >
              关于我们
            </Link>
            <Link
              to="/about"
              className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors"
            >
              隐私政策
            </Link>
            <Link
              to="/about"
              className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors"
            >
              免责声明
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}